import React from 'react';
import redial from 'redial';
import {withLegacyProviders} from '../LegacyComponentWrapper';

import Page from '@aboutyou/legacy-desktop/src/app/pages/OutfitOverview/OutfitOverviewPage';
import redialHandle from '@aboutyou/legacy-desktop/src/app/pages/OutfitOverview/redial';
import {LegacyDesktopStyles} from '../styles/LegacyBaseStyles';

const PageWithRedial = redial.provideHooks(redialHandle)(Page);

const LegacyOutfitOverviewPage = withLegacyProviders(PageWithRedial);

export const OutfitOverviewPage = () => {
  return (
    <>
      <div className={LegacyDesktopStyles} />
      <LegacyOutfitOverviewPage />
    </>
  );
};
